import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ConsoleComponent } from './console.component';
import { ConsoleMaintenanceComponent } from './components/console-maintenance/console-maintenance.component';
import { ConsoleSystemEventsComponent } from './components/console-system-events/console-system-events.component';

const routes: Routes = [
    {
        path: '',
        redirectTo: 'maintenance',
        pathMatch: 'full'
    },
    {
        path: '',
        component: ConsoleComponent,
        children: [
            {
                path: 'maintenance',
                children: [
                    {
                        path: '',
                        component: ConsoleMaintenanceComponent
                    }
                ]
            },
            {
                path: 'system-events',
                children: [
                    {
                        path: '',
                        component: ConsoleSystemEventsComponent
                    }
                ]
            }
        ]
    },
    {
        path: '**',
        redirectTo: 'maintenance'
    }
];

@NgModule({
    imports: [RouterModule.forChild(routes)],
    exports: [RouterModule]
})
export class ConsoleRoutingModule {}
